export default __webpack_public_path__ + "static/media/solicitarIcono.2b2f35f9.svg";